<template>
  <div>
    <button class="btn btn-info btn-icon" @click="addItem">
      <span class="ti-plus"></span>
      {{ "add" | setText("Добавить") }}
    </button>
    <add-item
      :openItem="true"
      @close="add = false"
      v-if="fields && fields.length && setLink && add === true"
      :fieldsFrom="fields"
      :getList="getList"
      :setLink="setLink"
      :cardLink="cardLink"
    />
    <div>
      <paper-table
        v-if="this.books.length"
        type="hover"
        :card="cardLink"
        :cardLink="cardLink"
        :data="this.books"
        :columns="columns"
        :removeItem="removeItem"
      ></paper-table>
    </div>
  </div>
</template>
<script>
import PaperTable from "@/components/PaperTable2";
import { cardGetList } from "@/plugins/functions";
export default {
  props: ["id"],
  components: {
    "paper-table": PaperTable,
    "add-item": () => import("@/components/Modals/AddItem"),
  },
  async created() {
    let query = Object.assign({}, this.$route.query);
    // let data = await this.cardContent(`disciplines`, query["item_discipline"])
    this.getList()
  },
  methods: {
    cardGetList: cardGetList,
    removeItem(itemID){
      this.$dialog
        .confirm("Вы точно хотите удалить?", {
          okText: "Удалить",
          cancelText: "Отмена",
        })
        .then(() => {
          this.$loading(true);
          this.$http
            .post(`${this.setLink}/${itemID}`, { _method: "DELETE" })
            .then((response) => {
              this.getList();
            })
            .catch((error) => {
              errorNotify(error, this.$notify);
            })
            .finally(() => {
              setTimeout(() => {
                this.$loading(false);
              }, 400);
            });
        })
        .catch(() => {});
    },
    addItem() {
      this.add = true;
    },
    async getList(loading = true, resetPage = false){
      let query = Object.assign({}, this.$route.query);
      let discipline = query["item_discipline"]
      this.itemLink = `${this.$store.state.secApiUrl}/school/subjects/${discipline}/classes/${this.id}/books`;
      this.setLink = `${this.$store.state.secApiUrl}/school/subjects/${discipline}/classes/${this.id}/books`;
      
      this.loading = true;
      if (loading) {
        this.$loading(true);
      }
      this.data = await this.cardGetList(this.itemLink)
      this.books = this.data.data
      this.data.class.course_name = Object.values(this.$store.state.courses).indexOf(this.data.class.course_id)
      this.$emit('info', this.data.class);
    }
  },
  data() {
    return {
      books: [],
      add: false,
      val: [],
      params: {},
      filters: [
        {
          key: "course",
          single: true,
          title: "Номер Класса",
        },
      ],
      fields: [
        {
          col: "col-12 col-md-12",
          key: "file",
          label: "Загрузите  файлы",
          type: "file",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_books",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "file_name",
          title: "Название файла",
          checkbox: false,
        },
        {
          key: "url",
        },
        {
          key: "created_at",
          dateTimeFormat: true,
        },
        {
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
